import { Skeleton } from "@/components/ui/skeleton"

export default function SlotsSkeleton() {
  return (
    <div className="mt-6 md:px-2 space-y-8">
      {["Morning", "Afternoon"].map((label, sectionIndex) => (
        <div key={label} className="animate-pulse">
          {/* Section Header */}
          <div className="flex items-center gap-2 mb-3">
            <Skeleton className="w-2 h-2 rounded-full" />
            <Skeleton className="w-16 h-3 rounded-full" />
            <div className="h-px flex-1 bg-gray-100" />
          </div>
          
          {/* Grid */}
          <div className="grid grid-cols-2 min-[480px]:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
            {Array.from({ length: sectionIndex === 0 ? 8 : 6 }).map((_, i) => (
              <div 
                key={i} 
                className="flex flex-col items-center justify-center py-3 px-2 rounded-xl border border-gray-100 bg-white h-[74px]"
              >
                <Skeleton className="w-16 h-4 mb-2 rounded-md" />
                <Skeleton className="w-12 h-3 rounded-full" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}


